export const NAME = 'news';